import { takeLatest, put, call, select, takeLeading } from 'redux-saga/effects';
import get from 'lodash/get';
import { REG_STEP } from './constants';

import {
  initRegistrationAction,
  setActiveRegistrationsAction,
  updateRegistrationAction,
  createProfileAction,
  getRegistrationsAction,
  setRegistrationProfileAction,
} from './actions';
import * as API from '../../utils/API';
import { loginUser, updateActiveProfile } from '../App/saga';
import { REGISTRATIONS } from '../../constants/endpointConstants';
import { selectUserProfiles, selectUserData } from '../App/selectors';
import route from '../../constants/routes';
import { setUserProfiles } from '../App/actions';

export function* initRegistration({ payload }) {
  try {
    if (get(payload, 'userRegData')) {
      const response = yield call(API.registerUser, get(payload, 'userRegData'));
      yield loginUser({
        payload: {
          email: get(payload, 'userRegData.email'),
          password: get(payload, 'userRegData.password'),
          isTrustedDevice: true,
        },
        isAfterRegister: true,
      });
      const createRegResponse = yield call(API.createRegistration, {
        ...get(payload, 'registration'),
        user: response.data,
      });
      window.location.replace(
        `${route.REGISTER}?step=${createRegResponse.data.step}&regtoken=${createRegResponse.data.token}`,
      );
    } else {
      const createRegResponse = yield call(API.createRegistration, {
        ...get(payload, 'registration'),
        user: get(payload, 'user'),
      });
      window.location.replace(
        `${route.REGISTER}?step=${createRegResponse.data.step}&regtoken=${createRegResponse.data.token}`,
      );
    }
  } catch (err) {
    yield put(setActiveRegistrationsAction.failure(err.message));
  } finally {
    yield put(setActiveRegistrationsAction.fulfill());
  }
}

export function* updateRegistration({ payload }) {
  try {
    const createRegResponse = yield call(
      API.updateRegistration,
      get(payload, 'registration.id'),
      get(payload, 'registration'),
    );
    if (payload.noReload) {
      yield put(setActiveRegistrationsAction.success(createRegResponse.data));
    } else {
      window.location.replace(
        `${route.REGISTER}?step=${createRegResponse.data.step}&regtoken=${createRegResponse.data.token}`,
      );
    }
  } catch (err) {
    yield put(setActiveRegistrationsAction.failure(err.message));
  } finally {
    yield put(setActiveRegistrationsAction.fulfill());
    if (payload?.callback) yield call(payload.callback);
  }
}

export function* createProfile({ payload }) {
  try {
    const response = yield call(API.createUserProfile, payload.profile);
    yield put(createProfileAction.success(response.data));
    const userProfiles = yield select(selectUserProfiles());
    yield put(setUserProfiles.success([...userProfiles, response.data]));
    yield call(updateActiveProfile, { payload: { profileId: response.data.id, fromReg: true } });
    yield call(updateRegistration, {
      payload: {
        registration: { ...get(payload, 'registration'), profile: { id: response.data.id } },
      },
    });
  } catch (err) {
    yield put(createProfileAction.failure(err.message));
  } finally {
    yield put(createProfileAction.fulfill());
  }
}

export function* restoreRegistration({ payload: { token } }) {
  try {
    const user = yield select(selectUserData());
    if (!user) return;
    const registrationsResponse = yield call(API.getList, REGISTRATIONS, {
      pagination: { page: 1, limit: 10000 },
      queryParams: {
        user_id: user.id,
      },
    });
    yield put(getRegistrationsAction.success(registrationsResponse.data));
    if (token) {
      const tokenRegistration = registrationsResponse.data.data.find(reg => reg.token && reg.token === token);
      if (tokenRegistration) {
        if (tokenRegistration.step !== REG_STEP.aborted && tokenRegistration.step !== REG_STEP.congrat) {
          yield put(setRegistrationProfileAction.success(tokenRegistration.profile));
          yield put(
            setActiveRegistrationsAction({
              ...tokenRegistration,
              step: tokenRegistration.step === REG_STEP.payment ? REG_STEP.paymentPlan : tokenRegistration.step,
            }),
          );
        }
      }
    }
  } catch (error) {
    yield put(getRegistrationsAction.failure(error.message));
  } finally {
    yield put(getRegistrationsAction.fulfill());
  }
}

export default function* registrationSaga() {
  yield takeLeading(initRegistrationAction.TRIGGER, initRegistration);
  yield takeLatest(updateRegistrationAction.TRIGGER, updateRegistration);
  yield takeLatest(createProfileAction.TRIGGER, createProfile);
  yield takeLatest(getRegistrationsAction.TRIGGER, restoreRegistration);
}
